var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSirt = function SvgSirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.259 0.910067C40.9734 0.197054 40.1761 -0.173917 39.4426 0.0798667L32.4132 2.51407C30.829 3.06265 29.7062 4.49564 29.5531 6.16519L28.4922 17.7224H31.4017L32.4381 6.42996C32.4875 5.89127 32.8501 5.42874 33.361 5.25186L40.3904 2.81803C41.1609 2.55106 41.5732 1.69229 41.259 0.910067Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6018 16.2734L33.9325 45.3509C33.8036 46.8491 32.5497 47.9997 31.0456 47.9997H13.6616C12.1576 47.9997 10.9037 46.8491 10.7748 45.3509L8.10547 16.2734H36.6018Z",
    fill: "#8BC34A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6898 16.2734L32.2715 31.7261L13.6592 45.1023H10.7617V45.2345L10.7723 45.3509C10.9012 46.8491 12.1552 47.9997 13.6592 47.9997H31.0432C32.5472 47.9997 33.8011 46.8491 33.93 45.3509L36.5994 16.2734H33.6898Z",
    fill: "#8BC34A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6013 17.7222H8.10498C7.30481 17.7222 6.65625 17.0736 6.65625 16.2734C6.65625 15.4733 7.30481 14.8247 8.10498 14.8247H36.6013C37.4015 14.8247 38.05 15.4733 38.05 16.2734C38.05 17.0736 37.4015 17.7222 36.6013 17.7222Z",
    fill: "#8BC34A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4008 17.7222L29.5199 38.2128L26.5664 38.6932L28.4912 17.7222",
    fill: "#8BC34A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4336 31.7261L13.6615 45.1023H31.0455L32.2738 31.7261H12.4336Z",
    fill: "#659C35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6904 26.4437C23.1274 25.0122 25.1628 24.5416 26.995 25.0283C27.4839 26.8531 27.0111 28.8797 25.5741 30.3113C24.1367 31.7424 22.1013 32.2134 20.2695 31.7263V28.8973C20.5094 27.9986 20.9822 27.1487 21.6904 26.4437Z",
    fill: "#00973C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0155 26.9901C23.0155 24.3746 21.7861 22.2539 20.2693 22.2539C18.7528 22.2539 17.5234 24.3746 17.5234 26.9901C17.5234 29.606 18.7528 31.7263 20.2693 31.7263C21.7861 31.7263 23.0155 29.606 23.0155 26.9901Z",
    fill: "#558B2F"
  })));
};
export default SvgSirt;